import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { serverUserRemoveFromIdentityPool } from '~src/userManagement/users/actions/ServerUserMenuActions';
import { IServerUserInfo } from '~src/userManagement/users/models/IServerUserInfo';

export const ServerUserRemoveFromIdentityPoolAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserRemoveFromIdentityPool,
  translateName: Messages.identityPools_ServerUserAction_ServerUserRemoveFromIdentityPool,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return FeatureFlags.identityPoolsEnabled && _targetItems.length === 1 && _targetItems[0].poolMemberships && _targetItems[0].poolMemberships.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserRemoveFromIdentityPool(targetItems)
};
